module.exports = __webpack_public_path__ + "f2ba6abd35e6b3caa9d30dcf40a1e548.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/stacked-bar-widget.png
// module id = 2408
// module chunks = 0